export default __webpack_public_path__ + "static/media/Ticketbooker.f03b6407.png";